import CherryTree from './flora/CherryTree.sprite.js';
import MagnoliaTree from './flora/MagnoliaTree.sprite.js';
import OakTree from './flora/OakTree.sprite.js';
import BlueberryPlant from './flora/BlueberryPlant.sprite.js';
import CatnipPlant from './flora/CatnipPlant.sprite.js';
import StrawberryPlant from './flora/StrawberryPlant.sprite.js';
import SunflowerPlant from './flora/SunflowerPlant.sprite.js';
import SweetPeaPlant from './flora/SweetPeaPlant.sprite.js';
import TomatoPlant from './flora/TomatoPlant.sprite.js';
import WatermelonPlant from './flora/WatermelonPlant.sprite.js';

export default [
    ...CherryTree.ANIMATIONS,
    ...MagnoliaTree.ANIMATIONS,
    ...OakTree.ANIMATIONS,
    ...BlueberryPlant.ANIMATIONS,
    ...CatnipPlant.ANIMATIONS,
    ...StrawberryPlant.ANIMATIONS,
    ...SunflowerPlant.ANIMATIONS,
    ...SweetPeaPlant.ANIMATIONS,
    ...TomatoPlant.ANIMATIONS,
    ...WatermelonPlant.ANIMATIONS,
];
